import eventBus from '@/lib/eventBus';

export const alert = {
  fail(message, cb) {
    this.command('fail', message, cb);
  },
  error(message, cb) {
    this.fail(message, cb);
  },
  warning(message) {
    this.command('warning', message);
  },
  success(message) {
    this.command('success', message);
  },
  confirm(message, cb) {
    this.command('confirm', message, cb);
  },
  command(type, message, cb = null) {
    const params = {
      type,
      message,
      cb,
    };
    eventBus.$emit('alert-command', params);
  },
};

export function AlertSetup(app) {
  app.config.globalProperties.$alert = alert;
}